"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Dropdown = _interopRequireDefault(require("../dropdown/Dropdown"));

var _Icons = require("./Icons");

var _variables = require("../common/variables.js");

var _useTheme = _interopRequireDefault(require("../useTheme"));

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _BackgroundColorContext = _interopRequireWildcard(require("../BackgroundColorContext"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var closeIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
}));

var hamburgerIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
}));

var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderDropdown, null, /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], props));
};

var HeaderDropdown = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  button {\n    background-color: transparent;\n    :hover {\n      background-color: transparent;\n    }\n  }\n"])));

var getLogoElement = function getLogoElement(themeInput, logoLabel) {
  if (!themeInput) return _Icons.dxcLogo;else if (typeof themeInput === "string") return /*#__PURE__*/_react["default"].createElement(LogoImg, {
    alt: logoLabel,
    src: themeInput
  });else return themeInput;
};

var Content = function Content(_ref) {
  var isResponsive = _ref.isResponsive,
      responsiveContent = _ref.responsiveContent,
      handleMenu = _ref.handleMenu,
      padding = _ref.padding,
      content = _ref.content;
  var backgroundType = (0, _react.useContext)(_BackgroundColorContext["default"]);
  return isResponsive ? /*#__PURE__*/_react["default"].createElement(MenuContent, {
    backgroundType: backgroundType
  }, responsiveContent(handleMenu)) : /*#__PURE__*/_react["default"].createElement(ContentContainer, {
    padding: padding,
    backgroundType: backgroundType
  }, content);
};

var DxcHeader = function DxcHeader(_ref2) {
  var _ref2$underlined = _ref2.underlined,
      underlined = _ref2$underlined === void 0 ? false : _ref2$underlined,
      content = _ref2.content,
      responsiveContent = _ref2.responsiveContent,
      onClick = _ref2.onClick,
      margin = _ref2.margin,
      padding = _ref2.padding,
      _ref2$tabIndex = _ref2.tabIndex,
      tabIndex = _ref2$tabIndex === void 0 ? 0 : _ref2$tabIndex;
  var colorsTheme = (0, _useTheme["default"])();
  var translatedLabels = (0, _useTranslatedLabels["default"])();
  var ref = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isResponsive = _useState2[0],
      setIsResponsive = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isMenuVisible = _useState4[0],
      setIsMenuVisible = _useState4[1];

  var handleResize = function handleResize() {
    setIsResponsive(window.matchMedia("(max-width: ".concat(_variables.responsiveSizes.medium, "rem)")).matches);
  };

  var handleMenu = function handleMenu() {
    if (isResponsive && !isMenuVisible) {
      setIsMenuVisible(!isMenuVisible);
    } else {
      setIsMenuVisible(!isMenuVisible);
    }
  };

  var headerLogo = (0, _react.useMemo)(function () {
    return getLogoElement(colorsTheme.header.logo, translatedLabels.formFields.logoAlternativeText);
  }, [colorsTheme.header.logo]);
  var headerResponsiveLogo = (0, _react.useMemo)(function () {
    return getLogoElement(colorsTheme.header.logoResponsive, translatedLabels.formFields.logoAlternativeText);
  }, [colorsTheme.header.logoResponsive]);
  (0, _react.useEffect)(function () {
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    !isResponsive && setIsMenuVisible(false);
  }, [isResponsive]);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: colorsTheme.header
  }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, {
    underlined: underlined,
    margin: margin,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(LogoAnchor, {
    tabIndex: onClick ? tabIndex : -1,
    interactuable: onClick ? true : false,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(LogoContainer, null, headerLogo)), isResponsive && responsiveContent && /*#__PURE__*/_react["default"].createElement(MainContainer, null, /*#__PURE__*/_react["default"].createElement(ChildContainer, {
    padding: padding
  }, /*#__PURE__*/_react["default"].createElement(HamburguerTrigger, {
    tabIndex: tabIndex,
    onClick: handleMenu
  }, hamburgerIcon, translatedLabels.header.hamburguerTitle)), /*#__PURE__*/_react["default"].createElement(ResponsiveMenu, {
    hasVisibility: isMenuVisible
  }, /*#__PURE__*/_react["default"].createElement(ResponsiveIconsContainer, null, /*#__PURE__*/_react["default"].createElement(ResponsiveLogoContainer, null, headerResponsiveLogo), /*#__PURE__*/_react["default"].createElement(CloseAction, {
    tabIndex: tabIndex,
    onClick: handleMenu,
    "aria-label": translatedLabels.header.closeIcon
  }, closeIcon)), /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.header.menuBackgroundColor
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    isResponsive: isResponsive,
    responsiveContent: responsiveContent,
    handleMenu: handleMenu,
    padding: padding,
    content: content
  }))), /*#__PURE__*/_react["default"].createElement(Overlay, {
    onClick: handleMenu,
    hasVisibility: isMenuVisible
  })), !isResponsive && /*#__PURE__*/_react["default"].createElement(_BackgroundColorContext.BackgroundColorProvider, {
    color: colorsTheme.header.backgroundColor
  }, /*#__PURE__*/_react["default"].createElement(Content, {
    isResponsive: isResponsive,
    responsiveContent: responsiveContent,
    handleMenu: handleMenu,
    padding: padding,
    content: content
  }))));
};

DxcHeader.Dropdown = Dropdown;

var HeaderContainer = _styledComponents["default"].header(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-bottom: ", ";\n  padding: ", ";\n  background-color: ", ";\n  border-bottom: ", ";\n  min-height: ", ";\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  box-sizing: border-box;\n"])), function (props) {
  return props.margin && (0, _typeof2["default"])(props.margin) !== "object" ? _variables.spaces[props.margin] : "0px";
}, function (props) {
  return "".concat(props.theme.paddingTop, " ").concat(props.theme.paddingRight, " ").concat(props.theme.paddingBottom, " ").concat(props.theme.paddingLeft);
}, function (props) {
  return props.theme.backgroundColor;
}, function (props) {
  return props.underlined && "".concat(props.theme.underlinedThickness, " ").concat(props.theme.underlinedStyle, " ").concat(props.theme.underlinedColor);
}, function (props) {
  return props.theme.minHeight;
});

var LogoAnchor = _styledComponents["default"].a(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n"])), function (props) {
  return props.interactuable ? "cursor: pointer" : "cursor: default; outline:none";
});

var LogoImg = _styledComponents["default"].img(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: ", ";\n  width: ", ";\n"])), function (props) {
  return props.theme.logoHeight;
}, function (props) {
  return props.theme.logoWidth;
});

var LogoContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: ", ";\n  width: ", ";\n  vertical-align: middle;\n"])), function (props) {
  return props.theme.logoHeight;
}, function (props) {
  return props.theme.logoWidth;
});

var ChildContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  width: calc(100% - 186px);\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n\n  justify-content: flex-end;\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n"])), function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) !== "object" ? _variables.spaces[props.padding] : "0px";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.top ? _variables.spaces[props.padding.top] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.right ? _variables.spaces[props.padding.right] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.bottom ? _variables.spaces[props.padding.bottom] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.left ? _variables.spaces[props.padding.left] : "";
});

var ContentContainer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  width: calc(100% - 186px);\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n  color: ", ";\n\n  justify-content: flex-end;\n  padding: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.contentColorOnDark : props.theme.contentColor;
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) !== "object" ? _variables.spaces[props.padding] : "0px";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.top ? _variables.spaces[props.padding.top] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.right ? _variables.spaces[props.padding.right] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.bottom ? _variables.spaces[props.padding.bottom] : "";
}, function (props) {
  return props.padding && (0, _typeof2["default"])(props.padding) === "object" && props.padding.left ? _variables.spaces[props.padding.left] : "";
});

var HamburguerTrigger = _styledComponents["default"].button(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 54px;\n  cursor: pointer;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  background-color: transparent;\n  :hover {\n    background-color: ", ";\n  }\n  &:focus {\n    outline: ", " auto 1px;\n  }\n  & > svg {\n    fill: ", ";\n  }\n  font-family: ", ";\n  font-style: ", ";\n  font-size: ", ";\n  text-transform: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), function (props) {
  return props.theme.hamburguerHoverColor;
}, function (props) {
  return props.theme.hamburguerFocusColor;
}, function (props) {
  return props.theme.hamburguerIconColor;
}, function (props) {
  return props.theme.hamburguerFontFamily;
}, function (props) {
  return props.theme.hamburguerFontStyle;
}, function (props) {
  return props.theme.hamburguerFontSize;
}, function (props) {
  return props.theme.hamburguerTextTransform;
}, function (props) {
  return props.theme.hamburguerFontWeight;
}, function (props) {
  return props.theme.hamburguerFontColor;
});

var MainContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-grow: 1;\n"])));

var ResponsiveMenu = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: ", ";\n\n  @media (max-width: ", "rem) and (min-width: ", "rem) {\n    //tablet\n    width: ", ";\n  }\n\n  @media (not((max-width: ", "rem) and (min-width: ", "rem))) {\n    //mobile phones\n    width: ", ";\n  }\n\n  height: 100vh;\n  padding: 20px;\n  transform: ", ";\n  opacity: ", ";\n  transition-property: transform, opacity;\n  transition-duration: 0.6s;\n  transition-timing-function: ease-in-out;\n  box-sizing: border-box;\n"])), function (props) {
  return props.theme.menuBackgroundColor;
}, function (props) {
  return props.theme.menuZindex;
}, _variables.responsiveSizes.large, _variables.responsiveSizes.small, function (props) {
  return props.theme.menuTabletWidth;
}, _variables.responsiveSizes.large, _variables.responsiveSizes.small, function (props) {
  return props.theme.menuMobileWidth;
}, function (props) {
  return props.hasVisibility ? "translateX(0)" : "translateX(100vw)";
}, function (props) {
  return props.hasVisibility ? "1" : "0.96";
});

var ResponsiveLogoContainer = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  max-height: ", ";\n  width: ", ";\n  display: flex;\n"])), function (props) {
  return props.theme.logoHeight;
}, function (props) {
  return props.theme.logoWidth;
});

var ResponsiveIconsContainer = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));

var CloseAction = _styledComponents["default"].button(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  padding: 6px;\n  height: 36px;\n  width: 36px;\n  border: 1px solid transparent;\n  border-radius: 2px;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  background-color: transparent;\n  :focus,\n  :focus-visible {\n    outline: ", " auto 1px;\n  }\n"])), function (props) {
  return props.theme.hamburguerFocusColor;
});

var MenuContent = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  color: ", ";\n"])), function (props) {
  return props.backgroundType === "dark" ? props.theme.contentColorOnDark : props.theme.contentColor;
});

var Overlay = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: ", ";\n  opacity: ", " !important;\n  visibility: ", ";\n  opacity: ", ";\n\n  @media (max-width: ", "rem) {\n    //mobile phones\n    display: none;\n  }\n\n  transition: opacity 0.2s 0.2s ease-in-out;\n  z-index: ", ";\n"])), function (props) {
  return props.theme.overlayColor;
}, function (props) {
  return props.theme.overlayOpacity;
}, function (props) {
  return props.hasVisibility ? "visible" : "hidden";
}, function (props) {
  return props.hasVisibility ? "1" : "0";
}, _variables.responsiveSizes.small, function (props) {
  return props.theme.overlayZindex;
});

var _default = DxcHeader;
exports["default"] = _default;